export default {"src":"/_next/static/media/DK.584d22b1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};